import { memo, useCallback } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { Switch } from '@aimsos/ui';

/**
 * "Extract claims from <folder>" (CT-5717): a `Switch` that applies at once, what
 * it means, the counter "N of M files read · N claims" and that Concierge may
 * use the files as context — inside the drive's card, the counter on the right,
 * as in the prototype. A sub-folder that follows its parent says
 * "Inherited from the folder above." A viewer who may not manage the drive sees
 * it disabled.
 */
const DriveExtractionToggle = memo(function DriveExtractionToggle({ name, extraction, canManage, saving, onChange }) {
  const { t } = useTranslation('unified-profiles');

  const handleChange = useCallback((next) => onChange(next), [onChange]);

  const description = [extraction.inherited ? t('knowledge.drive.extraction.inherited') : null, t('knowledge.drive.extraction.description')]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <Switch
            checked={extraction.enabled}
            onChange={handleChange}
            disabled={!canManage || saving}
            label={t('knowledge.drive.extraction.label', { name })}
            description={description}
          />
        </div>
        <p className="shrink-0 text-sm text-content-secondary">
          {t('knowledge.drive.extraction.counter', {
            read: extraction.filesRead,
            total: extraction.filesTotal,
            count: extraction.claimsTotal,
          })}
        </p>
      </div>
      <p className="text-xs text-content-muted">{t('knowledge.drive.extraction.context')}</p>
    </div>
  );
});

export default DriveExtractionToggle;
